import Icon from "@components/Icon";
import { colours, getColours, richTextHelper } from "@helpers";
import { Actioner, BuyFlowActionKeys, GTMActionKeys } from "@services/actioner";
import React, { useState, useEffect, useRef } from "react";
import Slider from "react-slick";
import styled from "styled-components";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import IconLinkButton from "@components/BuyForm/IconLinkButton";
import CTAButton from "@components/CTAButton";

import { useNavigation } from "@contexts/NavigationContainer";
import {
	ActivateFlowStepOrder,
	ActivateFlowOrderSteps,
} from "@helpers/ActivateFlowStep";
import TransformStringWithModal from "@helpers/transforStringWithModal";
import Curve from "../../../../public/images/Background.png";
import { useAtom } from "jotai";
import { productIdAtom } from "@contexts/buyAtoms";
import { simPlanSummaryAtom, simProductIdAtom } from "@contextsactivateAtoms";

const Container = styled.div`
  ${({ resetModuleMarginBottom }) => resetModuleMarginBottom === "Yes" && "margin-bottom: 0px !important"};
  /* background-color: ${(props) => getColours(props.backgroundColour)}; */
  box-sizing: border-box;
  position: relative;
  overflow: hidden;
  z-index: 0;
  &::before {
    content: "";
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-image: url(${(props) => props.backgroundImage});
    background-repeat: no-repeat;
    background-position: top center;
    background-size: 100% 485px;
    z-index: 0;
  }

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  /* padding: 40px 0px;
  @media (min-width: 834px) {
    padding: 40px 10%;
  } */
  .slick-track {
    display: flex !important;
    justify-content: center;
    margin-bottom: 40px;
  }
  .slick-track {
    display: flex !important;
    height: 100%;
  }

  .slick-slide {
    height: auto;
  }
  .slick-slide > div {
    height: 100%;
  }
  .slick-slide > div > div {
    height: ${(props) => (props.allNull ? "100%" : "calc(100% - 40px)")};
  }
`;

const MainPromo = styled.div`
  border-radius: 12px;
  background-color: ${(props) => getColours(props.promoBackgroundColour)};
  width: 304px;
  min-height: 56px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  margin-bottom: 12px;
  gap: 27px;
  padding: 4px 14px;
  z-index: 1;
  font-family: var(--euclid-medium);
  @media (min-width: 1166px) {
    width: 1136px;
    gap: 16px;
    margin-bottom: 32px;
  }
  div {
    color: ${colours.MIDNIGHT_BLUE};
    p {
      font-weight: bold;
      line-height: 24px;
      @media (min-width: 1165px) {
        display: inline;
      }
    }
    p:nth-child(2),
    p:nth-child(3) {
      font-weight: normal;
    }
  }
`;
const CardsContainer = styled.div`
  margin-top: 62px;
  display: flex;
  gap: 16px;
  justify-content: center;

  width: 1136px;

  @media (max-width: 1165px) {
    display: none;
  }
`;

const CarouselCardContainer = styled.div`
  .slick-list {
    padding: 0px;
  }
  .slick-slider {
    width: 400px;
  }
  .slick-slide {
    border-radius: 12px;
    margin: 0 8px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
`;

const MobileCardDiv = styled.div`
  z-index: 2;
`;

const Card = styled.div`
  display: flex;
  padding: 0px 23px;
  flex-direction: column;
  justify-content: flex-start;
  border-radius: 12px;

  background: #fff;
  position: relative;
  margin-top: 64px;

  @media (min-width: 1168px) {
    width: 368px;
    margin-top: 0px;
    padding: 0px 32px;

    border: 2px solid ${colours.PEACH};
  }
`;
const MobileCard = styled.div`
  display: flex;
  padding: 0px 23px;
  flex-direction: column;
  justify-content: flex-start;
  border-radius: 12px;
  z-index: 2;

  background: #fff;
  box-shadow: 0px 7px 20px 0px rgba(0, 0, 0, 0.1);
  position: relative;
  height: 100%;
`;

const InnerLayout = styled.div`
  display: flex;
  padding: 32px 0px;
  flex-direction: column;
  align-items: center;
  gap: 24px;
  height: 100%;
  @media (min-width: 1168px) {
    padding: 40px 0px 71px 0px;
    padding: ${(props) => (props.nonePlanPage ? "40px 0px 40px 0px" : "40px 0px 71px 0px")};
    gap: 32px;
  }

  hr {
    width: 256px;
    background-color: #e0e0e0;
    border: none;
    height: 2px;
    margin: 0;
  }
  @media (min-width: 1168px) {
    hr {
      width: 304px;
    }
  }
`;

const Heading = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  #month {
    display: flex;
    justify-content: center;
    align-items: baseline;
    margin-top: 8px;
    font-size: 24px;
  }
  @media (min-width: 1168px) {
    #month {
      font-size: 30px;
      margin-top: 4px;
    }
  }
`;

const FeatureContent = styled.div`
  display: flex;
  flex-direction: column;
  #feature-name {
    font-size: 16px !important;
    font-family: ${(props) =>
			props.fontBoldness
				? "var(--euclid-regular) !important"
				: "var(--euclid-medium) !important"};
    font-weight: 700;
  }
  p {
    font-family: var(--euclid-medium) !important;
    margin-bottom: 8px;
  }
  #desktop {
    font-family: ${(props) =>
			props.fontBoldness
				? "var(--euclid-regular) !important"
				: "var(--euclid-medium) !important"};
    font-size: 18px !important;
  }
  p:not(#feature-name) {
    font-size: 14px;
  }
  span {
    font-size: 14px;
    line-height: 25px;
    padding-top: 5px;
  }
`;

const Features = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
  padding: ${(props) => props.paddingForNoneProductPages && "0px 12px"};
  hr {
    width: 256px;
    background-color: #e0e0e0;
    border: none;
    height: 2px;
  }
  @media (min-width: 1165px) {
    hr {
      width: 304px;
    }
  }
`;

const FeatureItem = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 16px;
`;

const PromoLabel = styled.div`
  display: flex;
  height: 40px;
  padding: 8px 14px;
  justify-content: center;
  align-items: center;
  border-radius: 12px 12px 0px 0px;
  background: ${colours.MIDNIGHT_BLUE};
  width: 326px;
  position: absolute;
  top: -40px;
  left: 5.3%;
  z-index: 999;

  box-sizing: border-box;
  @media (max-width: 1165px) {
    width: 260px;
    left: 6.6%;
  }
`;

const PromoLabelContent = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 7px;
  font-weight: bold;

  span {
    color: white;
  }
`;
const Terms = styled.span`
  margin-top: 8px;
  width: 307px;
  p,
  b {
    font-size: 14px;
  }
  @media (min-width: 1165px) {
    width: 928px;
    text-align: center;
    margin-top: 32px;
  }
`;

const SliderButtonDiv = styled.div`
  display: flex;
  flex-direction: row;
  background: #f5f5f5;
  border-radius: 12px;
  width: 304px;
  height: 57px;
  margin-bottom: 16px;
  z-index: 1;
`;

const SliderButton = styled.span`
  background: #f5f5f5;

  width: 100% !important;
  height: 57px;
  min-width: inherit;
  padding: 0 !important;
  border: 2px solid
    ${(props) => (props.active ? `${colours.MIDNIGHT_BLUE}` : "transparent")};
  background: ${(props) => props.active && `${colours.WHITE}`};
  border-radius: 12px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  cursor: pointer;

  p {
    font-family: var(--euclid-medium) !important;
  }
  h7 {
    color: ${colours.MIDNIGHT_BLUE};
    font-size: 14px;
    font-weight: 400;
    font-family: var(--euclid-regular) !important;
  }
`;

const FooterNavigation = styled.div`
  width: 307px;
  p,
  b {
    font-size: 14px;
  }
  @media (min-width: 1165px) {
    width: 100%;
    text-align: center;
    margin-top: 32px;
  }
  display: flex;
  flex-direction: row;
  z-index: 1;
  justify-content: "flex-start";
  margin-top: 0.75rem;
  button {
    border: none !important;
    &:hover {
      border: none !important;
    }
  }
`;
const mainPromoIconSizesDesktop = {
	iconMobile: 40,
	iconTablet: 40,
	iconLaptop: 40,
	iconDesktop: 40,
	iconDesktopLarge: 40,
};
const mainPromoIconSizes = {
	iconMobile: 23,
	iconTablet: 23,
	iconLaptop: 23,
	iconDesktop: 23,
	iconDesktopLarge: 23,
};
const featurePromoIconSizes = {
	iconMobile: 23,
	iconTablet: 23,
	iconLaptop: 23,
	iconDesktop: 23,
	iconDesktopLarge: 23,
};
const featuresIconSizes = {
	iconMobile: 24,
	iconTablet: 24,
	iconLaptop: 40,
	iconDesktop: 40,
	iconDesktopLarge: 40,
};
const featuresIconSizesNonePlanPages = {
	iconMobile: 24,
	iconTablet: 24,
	iconLaptop: 24,
	iconDesktop: 24,
	iconDesktopLarge: 24,
};

const MassRetailPlanCarousel = ({ massRetailcarouselData }) => {
	const [simPlanSummary] = useAtom(simPlanSummaryAtom);
	const [simProductId] = useAtom(simProductIdAtom);

	useEffect(() => {
		const originalRetailCustomerSimPlan =
			simPlanSummary?.purchasedProducts[0]?.name;

		if (originalRetailCustomerSimPlan) {
			sessionStorage.setItem(
				"originalRetailCustomerSimPlan",
				originalRetailCustomerSimPlan,
			);
		}
	}, [simPlanSummary]);

	const [, setProductId] = useAtom(productIdAtom);

	const { routeName, navigate } = useNavigation();
	let planType = "";

	const planPromos = massRetailcarouselData?.fields?.individualPlans.map(
		(i) => i.planPromo,
	);
	const allNull = planPromos.every((item) => item === null);
	const resetModuleMarginBottom =
		massRetailcarouselData?.fields?.removeNegativeSpacingBelowModule;
	const settings = {
		dots: false,
		infinite: false,
		speed: 500,
		slidesToShow: 1,
		slidesToScroll: 1,

		responsive: [
			{
				breakpoint: 1165,
				settings: {
					centerMode: true,
					centerPadding: "40px",
					slidesToShow: 1,
					slidesToScroll: 1,
					infinite: false,
					arrows: false,
				},
			},
		],
	};

	const [activeIndex, setActiveIndex] = useState(0);
	const buttonText = activeIndex !== 0 ? "Upgrade" : "Confirm";

	const [isScreenSmall, setIsScreenSmall] = useState(false);
	const [includedPlan, setIncludedPlan] = useState();
	const sliderRef = useRef();

	const handleBack = () => {
		const currentIndex = ActivateFlowStepOrder[routeName];
		if (currentIndex < 1) return;
		const previousRouteName = ActivateFlowOrderSteps[currentIndex - 1];
		navigate(previousRouteName);
	};

	const handleSlideChange = (index) => {
		setActiveIndex(index);
		sliderRef.current.slickGoTo(index);
	};
	const handleBrazeEvent = (planName, planPrice, PlanDataInclusion) => {
		Actioner.trigger(BuyFlowActionKeys.BUY_SET_PLAN, {
			plan_name: planName,
			data_inclusion: PlanDataInclusion,
			prices: planPrice,
		});
	};

	useEffect(() => {
		const updateIsScreenSmall = () => {
			if (typeof window !== "undefined") {
				setIsScreenSmall(window.innerWidth <= 1165);
			}
		};

		if (typeof window !== "undefined") {
			updateIsScreenSmall();

			window.addEventListener("resize", updateIsScreenSmall);

			return () => window.removeEventListener("resize", updateIsScreenSmall);
		}
	}, []);

	useEffect(() => {
		if (!simPlanSummary) {
			return;
		}
		let retailPlan = `<p>Your felix SIM includes:</p> <p>$${simPlanSummary.purchasedProducts[0]?.realValue} credit on the first month </p>`;
		if (simPlanSummary.purchasedProducts[0]?.campaigns) {
			retailPlan += `<p> ${simPlanSummary.purchasedProducts[0]?.campaigns[0]?.title}</p>`;
		}

		setIncludedPlan(retailPlan);
	}, [simPlanSummary]);

	const createHandleButtonClick = (plan) => () => {
		setProductId(simProductId);

		handleBrazeEvent(plan.planName, plan.planPrice, plan.planName);
		Actioner.trigger(GTMActionKeys.FORM_STEP_COMPLETE, {
			formName: "web_activate_retail",
			formStepName: routeName,
		});
	};

	const nonePlanPageTheme =
		massRetailcarouselData?.fields?.nonePlanPage === "Yes";

	const getFilteredPlans = (id) => {
		switch (id) {
			case 1:
				planType = "Unlimited";
				return massRetailcarouselData?.fields?.individualPlans.filter(
					(plan) => plan?.fields?.planName === "Unlimited",
				);
			case 11:
				planType = "50GB";
				return massRetailcarouselData?.fields?.individualPlans.filter(
					(plan) =>
						plan?.fields?.planName === "Unlimited" ||
						plan?.fields?.planName === "50GB",
				);
			case 10:
				planType = "25GB";
				return massRetailcarouselData?.fields?.individualPlans;
			default:
				return [];
		}
	};

	const filteredPlans = getFilteredPlans(simProductId);
	console.log(filteredPlans?.map((plan, index) => plan));

	return (
		<>
			<Container
				id="plan-selector"
				resetModuleMarginBottom={resetModuleMarginBottom}
				backgroundColour={massRetailcarouselData?.fields?.backgroundColour}
				backgroundImage={nonePlanPageTheme && Curve}
				allNull={allNull}
			>
				{!isScreenSmall && (
					<>
						<MainPromo
							data-testid="main-promo"
							promoBackgroundColour={
								massRetailcarouselData?.fields?.promoBackgroundColour
							}
						>
							<Icon
								iconName={massRetailcarouselData?.fields?.promoIconRef}
								iconSizes={mainPromoIconSizesDesktop}
								alt=" promo icon"
							/>
							<div dangerouslySetInnerHTML={{ __html: includedPlan }} />
						</MainPromo>
						{massRetailcarouselData?.fields?.promoSubcopy && !isScreenSmall && (
							<p style={{ marginBottom: "24px", zIndex: 99 }}>
								{massRetailcarouselData?.fields?.promoSubcopy}
							</p>
						)}
					</>
				)}

				<CardsContainer>
					{filteredPlans?.map((plan) => (
						<Card key={plan?.sys?.id} className="card">
							{plan?.fields?.planPromo && (
								<PromoLabel>
									<PromoLabelContent>
										<Icon
											iconName={plan?.fields?.planPromoIconRef}
											iconSizes={featurePromoIconSizes}
											alt="promo icon"
										/>
										<span>{plan?.fields?.planPromo}</span>
									</PromoLabelContent>
								</PromoLabel>
							)}
							<InnerLayout
								nonePlanPage={
									massRetailcarouselData?.fields?.nonePlanPage === "Yes"
								}
							>
								<Heading>
									<p style={{ fontSize: "2.25rem" }}>
										{plan?.fields?.planName}
									</p>
									<p>{plan?.fields?.planNameSmallCopy}</p>
									<p id="month">
										${plan?.fields?.planPrice}{" "}
										<span style={{ fontSize: "18px" }}>/month</span>
									</p>
								</Heading>
								{!nonePlanPageTheme && <hr />}
								<Features paddingForNoneProductPages={nonePlanPageTheme}>
									{plan?.fields?.items?.map((item, itemIndex) => (
										<React.Fragment key={itemIndex}>
											<FeatureItem>
												<Icon
													iconName={item?.fields?.iconRef}
													iconSizes={
														!nonePlanPageTheme
															? featuresIconSizes
															: featuresIconSizesNonePlanPages
													}
													alt="feature icon"
												/>
												<FeatureContent fontBoldness={nonePlanPageTheme}>
													{item?.fields?.text !== null ? (
														<p id="desktop">{item?.fields?.header}</p>
													) : (
														<span id="desktop">
															{item?.name && (
																<TransformStringWithModal
																	original={item?.fields?.header}
																	textForLightbox={
																		item?.fields?.textForLightbox
																	}
																	lightboxContent={
																		item?.fields?.lightboxContent
																	}
																/>
															)}
														</span>
													)}
													{!nonePlanPageTheme && item?.fields?.text && (
														<TransformStringWithModal
															original={
																item.fields.text?.content[0]?.content[0]
															}
															textForLightbox={item?.fields?.textForLightbox}
															lightboxContent={item.fields.lightboxContent}
														/>
													)}
												</FeatureContent>
											</FeatureItem>
											{!nonePlanPageTheme && <hr />}
										</React.Fragment>
									))}
								</Features>
								<span
									style={{
										display: "flex",
										flexDirection: "column",
										alignItems: "center",
										gap: "16px",
										width: "100%",
									}}
								>
									{plan?.fields?.ctaButtonLabel && (
										<CTAButton
											onClick={createHandleButtonClick(plan)}
											url={`/buy?id=${plan?.fields?.ctaButtonUrl}endid&simChannel=RETAIL&simProductId=${simProductId}`}
											ctaButtonColour={plan?.fields?.ctaButtonColour}
											gtmCtaText={plan?.fields?.ctaButtonLabel}
											gtmCtaPosition="mass-retail-activate"
										>
											{plan?.fields?.planName === planType
												? "Confirm"
												: "Upgrade"}
										</CTAButton>
									)}
									{(plan?.fields?.relativeUrl || plan?.fields?.linkUrl) &&
										plan?.fields?.linkText && (
											<a
												href={
													plan?.fields?.relativeUrl || plan?.fields?.linkUrl
												}
											>
												{plan?.fields?.linkText}
											</a>
										)}
								</span>
							</InnerLayout>
						</Card>
					))}
				</CardsContainer>
				{isScreenSmall && (
					<>
						<MainPromo
							promoBackgroundColour={
								massRetailcarouselData?.fields?.promoBackgroundColour
							}
							data-testid="main-promo-mobile"
						>
							<Icon
								iconName={massRetailcarouselData?.fields?.promoIconRef}
								iconSizes={mainPromoIconSizes}
								alt="main promo icon"
							/>
							<div dangerouslySetInnerHTML={{ __html: includedPlan }} />
						</MainPromo>
						{massRetailcarouselData?.fields?.promoSubcopy && (
							<p
								style={{ marginBottom: "24px", zIndex: 99, maxWidth: "304px" }}
							>
								{massRetailcarouselData?.fields?.promoSubcopy}
							</p>
						)}

						{planType !== "Unlimited" && (
							<SliderButtonDiv>
								{filteredPlans?.map((plan, index) => (
									<SliderButton
										key={plan?.sys?.id}
										onClick={() => handleSlideChange(index)}
										active={index === activeIndex}
									>
										<h7>{plan?.fields?.planName}</h7>
										<p>${plan?.fields?.planPrice}</p>
									</SliderButton>
								))}
							</SliderButtonDiv>
						)}

						<CarouselCardContainer>
							<Slider
								ref={sliderRef}
								afterChange={(newSlide) => handleSlideChange(newSlide)}
								initialSlide={activeIndex}
								{...settings}
							>
								{filteredPlans?.map((plan, index) => {
									const isHidden = index !== activeIndex;
									return (
										<MobileCardDiv
											key={plan?.sys?.id}
											className="mobile-card-div"
										>
											{!allNull && <div style={{ height: "40px" }} />}
											<MobileCard className="mobile-content-card">
												{plan?.fields?.planPromo && (
													<PromoLabel tabIndex={isHidden ? -1 : 0}>
														<PromoLabelContent>
															<Icon
																iconName={plan?.fields?.planPromoIconRef}
																alt="plan promo icon"
															/>
															<span>{plan?.fields?.planPromo}</span>
														</PromoLabelContent>
													</PromoLabel>
												)}
												<InnerLayout>
													<Heading>
														<p
															style={{ fontSize: "2.25rem" }}
															tabIndex={isHidden ? -1 : 0}
														>
															{plan?.fields?.planName}
														</p>
														<p id="month">
															${plan?.fields?.planPrice}{" "}
															<span style={{ fontSize: "18px" }}>/month</span>
														</p>
													</Heading>
													{!nonePlanPageTheme && <hr />}
													<Features
														paddingForNoneProductPages={nonePlanPageTheme}
													>
														{plan?.fields?.items.map((item) => (
															<React.Fragment key={item?.fields?.header}>
																<FeatureItem>
																	<Icon
																		iconName={item?.fields?.iconRef}
																		iconSizes={featuresIconSizes}
																		alt="feature icon"
																	/>
																	<FeatureContent
																		fontBoldness={nonePlanPageTheme}
																	>
																		<p id="feature-name">
																			{item?.fields?.header && (
																				<TransformStringWithModal
																					original={item?.fields?.header}
																					textForLightbox={
																						item?.fields?.textForLightbox
																					}
																					lightboxContent={
																						item?.fields?.lightboxContent
																					}
																				/>
																			)}
																		</p>

																		<p>
																			{item?.fields?.text && (
																				<TransformStringWithModal
																					original={
																						item.fields.text?.content[0]
																							?.content[0]
																					}
																					textForLightbox={
																						item?.fields?.textForLightbox
																					}
																					lightboxContent={
																						item.fields.lightboxContent
																					}
																				/>
																			)}
																		</p>
																	</FeatureContent>
																</FeatureItem>
																{!nonePlanPageTheme && <hr />}
															</React.Fragment>
														))}
													</Features>
													{plan?.fields?.ctaButtonLabel && (
														<span
															style={{
																display: "flex",
																flexDirection: "column",
																alignItems: "center",
																gap: "16px",
															}}
														>
															<CTAButton
																onClick={createHandleButtonClick(plan)}
																url={`/buy?id=${plan?.fields?.ctaButtonUrl}endid&simChannel=RETAIL&simProductId=${simProductId}`}
																ctaButtonColour={plan?.fields?.ctaButtonColour}
																gtmCtaText={plan?.fields?.ctaButtonLabel}
																gtmCtaPosition="mass-retail-activate"
															>
																{buttonText}
															</CTAButton>
															{(plan?.fields?.relativeUrl ||
																plan?.fields?.linkUrl) &&
																plan?.fields?.linkText && (
																	<a
																		href={
																			plan?.fields?.relativeUrl ||
																			plan?.fields?.linkUrl
																		}
																	>
																		{plan?.fields?.linkText}
																	</a>
																)}
														</span>
													)}
												</InnerLayout>
											</MobileCard>
										</MobileCardDiv>
									);
								})}
							</Slider>
						</CarouselCardContainer>
					</>
				)}
				<FooterNavigation>
					<IconLinkButton
						iconName="chevron-left"
						onClick={handleBack}
						iconWidth="24px"
						marginRight
					>
						Back
					</IconLinkButton>
				</FooterNavigation>

				<Terms style={{ zIndex: "9999" }}>
					{richTextHelper(massRetailcarouselData?.fields?.tsAndCs)}
				</Terms>
			</Container>
		</>
	);
};

export default MassRetailPlanCarousel;
